import React, {createContext} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import './accets/fonts/Cormorant/CormorantGaramond-Regular.ttf'
import UserStore from "./store/UserStore";
import TaskStore from "./store/TaskStore";
import PriorityStore from "./store/PriorityStore";
import FileStore from "./store/FileStore";
import StatementStore from "./store/StatementStore";
import CommentStore from "./store/CommentStore";
import SettingStore from "./store/SettingStore";
import TrackingStore from "./store/TrackingStore";

export const Context = createContext(null)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Context.Provider value={{
        userStore: new UserStore(),
        taskStore: new TaskStore(),
        priorityStore: new PriorityStore(),
        fileStore: new FileStore(),
        statementStore: new StatementStore(),
        commentStore: new CommentStore(),
        settingStore: new SettingStore(),
        trackingStore: new TrackingStore()
    }}>
        <BrowserRouter>
            <React.StrictMode>
                <App />
            </React.StrictMode>
        </BrowserRouter>
    </Context.Provider>,

);

reportWebVitals();
